import { ShipmentMethodName } from "@redotech/redo-return-core-common/draft-return/draft-return-enums";

/** Whether the return's shipment method charges the customer a "convenience
 * fee" (FedEx Easy Returns / BlueYonder) vs a regular return shipping fee.
 * Determines the shipping-fee label in the summary card. */
export function isConvenienceFeeMethod(
  shipmentMethod: ShipmentMethodName | undefined,
): boolean {
  return shipmentMethod === ShipmentMethodName.BLUE_YONDER;
}
